import { AgeCategory } from '@mews-commander/data-access';
import { useLocalizeProperty } from '@mews/framework';

interface AgeCategoryNameProps {
    ageCategory: AgeCategory;
}

export const AgeCategoryName = ({ ageCategory }: AgeCategoryNameProps) => {
    // Placed in connected components because of this selector
    const localizeProperty = useLocalizeProperty();
    const shortName = localizeProperty(ageCategory.shortName);

    return <span>{shortName || localizeProperty(ageCategory.name)}</span>;
};
